const END_POINT = '/traffic-sources'

import BasicCrudAPI from './basicCrud.api.js'

const TrafficSourcesAPI = new BasicCrudAPI(END_POINT)

export default TrafficSourcesAPI
